module.exports = "<md-table-container class=hq-table-container> <table md-table> <thead md-head> <tr md-row> <th md-column><span translate>H_CM</span></th> <th md-column ng-repeat=\"digit in $ctrl.digits\">{{ ::digit }}</th> </tr> </thead> <tbody md-body> <tr md-row ng-repeat=\"row in $ctrl.tableRows\"> <td md-cell>{{ ::row.decade }}</td> <td md-cell ng-repeat=\"value in row.dischargeValues track by $index\"> {{ ::value }} </td> </tr> </tbody> </table> </md-table-container>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/discharge/table.html
 ** module id = 225
 ** module chunks = 0
 **/